import React, { useState } from 'react';
import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PageSlice } from '@contracts';
import TourItem from '@components/shared/TourItem';
import FadeIn from './FadeIn';

interface Props {
  slice: PageSlice;
}

const Tour: React.FC<Props> = ({ slice }) => {
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>();
  const tourItems = slice.items ?? [];
  const backgroundColor = slice.primary?.background_color;
  const textColor = slice.primary?.text_color;
  const image = getImage(slice.primary.image);
  const imageAlt = slice.primary.image.alt ?? '';

  function handleSetSelectedIndex(idx: number) {
    const isAleadySelected = idx === selectedIndex;
    if (isAleadySelected) {
      setSelectedIndex(undefined);
    } else {
      setSelectedIndex(idx);
    }
  }

  return (
    <FadeIn>
      <Container $backgroundColor={backgroundColor ?? ''} $textColor={textColor ?? ''}>
        <Inner>
          <ImgWrapper>{image && <GatsbyImage image={image} alt={imageAlt} />}</ImgWrapper>
          <Flex>
            <DL>
              <Line />
              {tourItems.map((item: any, index: number) => {
                const { title, text } = item;
                const isSelected = selectedIndex === index;
                return (
                  <TourItem
                    key={index}
                    title={title.text}
                    description={text.html}
                    isSelected={isSelected}
                    handleSetSelectedIndex={handleSetSelectedIndex}
                    index={index}
                  />
                );
              })}
            </DL>
          </Flex>
        </Inner>
      </Container>
    </FadeIn>
  );
};

export default Tour;

interface IContainer {
  $backgroundColor?: string;
  $textColor?: string;
}

const Container = styled.div<IContainer>`
  background: ${(props) => (props.$backgroundColor ? props.$backgroundColor : '')};
  color: ${(props) => (props.$textColor ? props.$textColor : '')};
  width: 100%;
  padding: 60px 0;
  @media only screen and (max-width: 1000px) {
    padding: 40px;
  }
`;

const Inner = styled.div`
  display: flex;
  max-width: 1100px;
  margin: 0 auto;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
    padding: 0;
  }
`;

const ImgWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  padding: 0 40px;
  @media (max-width: 1000px) {
    width: 300px;
    margin-bottom: 30px;
  }

  @media (max-width: 500px) {
    width: 200px;
    margin-bottom: 20px;
  }
`;

const ImgStyled = styled.img`
  width: 100%;
  height: auto;
`;

const Flex = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 80px;
  @media only screen and (max-width: 1000px) {
    max-width: 100%;
    padding: 0;
  }
`;

const Line = styled.hr`
  width: 100%;
  border: none;
  border-top: solid 1px rgba(0, 0, 0, 0.5);
`;

const DL = styled.dl`
  width: 100%;
  margin: 0;
`;
